"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_dnd_1 = require("react-dnd");
var MediaLibrary_module_css_1 = __importDefault(require("./MediaLibrary.module.css"));
var MediaLibraryEditableName_1 = __importDefault(require("./MediaLibraryEditableName"));
var ThumbnailSmall = function (_a) {
    var item = _a.item, isFolder = _a.isFolder, permissions = _a.permissions, selectedMediaIds = _a.selectedMediaIds, selectedFolderIds = _a.selectedFolderIds, handleChangeFolderName = _a.handleChangeFolderName, folderPermissions = _a.folderPermissions;
    var _b = (0, react_1.useState)(null), previewImage = _b[0], setPreviewImage = _b[1];
    var isSelected = selectedFolderIds.includes(item.id);
    var handleSave = function (folderId, newName) {
        if (isFolder) {
            handleChangeFolderName(item.id, newName);
        }
    };
    var handleNameClick = function (e) {
        if (isFolder && isSelected) {
            e.stopPropagation();
            e.preventDefault();
        }
    };
    var _c = (0, react_dnd_1.useDrag)({
        type: isFolder ? "FOLDER" : "MEDIA",
        item: function () {
            var id = isFolder ? item.id : item.originalId;
            return {
                id: id,
                type: isFolder ? "FOLDER" : "MEDIA",
                selectedMediaIds: selectedMediaIds,
                selectedFolderIds: selectedFolderIds,
            };
        },
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging(),
        }); },
    }), isDragging = _c[0].isDragging, drag = _c[1], preview = _c[2];
    (0, react_1.useEffect)(function () {
        if (item.thumbnailUrl) {
            var img_1 = new Image();
            img_1.onload = function () {
                var canvas = document.createElement("canvas");
                canvas.width = 50;
                canvas.height = 28;
                var ctx = canvas.getContext("2d");
                ctx.globalAlpha = 0.7;
                ctx.drawImage(img_1, 0, 0);
                setPreviewImage(canvas.toDataURL());
            };
            img_1.src = item.thumbnailUrl;
            return function () {
                img_1.onload = null;
            };
        }
    }, [item.thumbnailUrl]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        previewImage && react_1.default.createElement(react_dnd_1.DragPreviewImage, { connect: preview, src: previewImage }),
        react_1.default.createElement("div", { key: item.id, className: MediaLibrary_module_css_1.default["thumbnail-container-small"], style: { opacity: 1, width: "100%" } },
            isFolder ? (react_1.default.createElement("div", { ref: drag, style: { opacity: isDragging ? 0.5 : 1 } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFolder, className: MediaLibrary_module_css_1.default["folder-icon-small"] }))) : (item.thumbnailUrl ? (react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default.file_placeholder_small, ref: drag, style: { opacity: isDragging ? 0.5 : 1, textAlign: "center" } },
                react_1.default.createElement("img", { src: item.thumbnailUrl, className: MediaLibrary_module_css_1.default["thumbnail-image-small"], alt: "Thumbnail" }))) : (react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default.file_placeholder_small, ref: drag, style: { opacity: isDragging ? 0.5 : 1, textAlign: "center" } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFile, className: MediaLibrary_module_css_1.default["file-icon-small"] })))),
            react_1.default.createElement("div", { className: "".concat(MediaLibrary_module_css_1.default["thumbnail-text-small"], " ns-font-family"), title: item.name, onClick: handleNameClick }, isFolder && isSelected ? (react_1.default.createElement(MediaLibraryEditableName_1.default, { id: item.id, name: item.name, permissions: permissions, onSave: handleSave, folderPermissions: folderPermissions, style: { fontSize: "0.875rem", marginLeft: "10px", textAlign: "left", width: "100%", minHeight: "20px", letterSpacing: "inherit", borderBottom: "1px solid #D2D2D2" }, viewMode: "list" })) : (react_1.default.createElement("input", { type: "text", value: item.name, readOnly: true, className: "".concat(MediaLibrary_module_css_1.default["thumbnail-text-small"], " ns-font-family"), style: {
                    marginLeft: "10px",
                    minHeight: "20px",
                    letterSpacing: "inherit",
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                }, onFocus: function (e) { return e.target.blur(); } }))))));
};
exports.default = ThumbnailSmall;
